import { callFes } from '../index';

export const createConversation = async (
  data: MilesPosNotesIntegrationService.Components.Schemas.CreateConversationRequest
): Promise<MilesPosNotesIntegrationService.Components.Schemas.Conversation> => {
  return callFes.postMiles('conversations', data);
};

export const getConversation = async (
  conversationId: string
): Promise<MilesPosNotesIntegrationService.Components.Schemas.GetConversationByIdResponse> => {
  return callFes.getMiles(`conversations/${conversationId}`);
};

export const updateConversation = async (
  conversationId: string,
  data: MilesPosNotesIntegrationService.Components.Schemas.UpdateConversationRequest
): Promise<MilesPosNotesIntegrationService.Components.Schemas.Conversation> => {
  return callFes.patchMiles(`conversations/${conversationId}`, data);
};

export const getMessagesForConversation = async (
  conversationId: string,
  since?: string
): Promise<MilesPosNotesIntegrationService.Components.Schemas.ConversationMessagesResponse> => {
  const url = since
    ? `conversations/${conversationId}/messages?since=${encodeURIComponent(since)}`
    : `conversations/${conversationId}/messages`;
  return callFes.getMiles(url);
};

export const addMessage = async (
  conversationId: string,
  data: MilesPosNotesIntegrationService.Components.Schemas.CreateMessageRequest
): Promise<MilesPosNotesIntegrationService.Components.Schemas.CreateMessageResponse> => {
  return callFes.postMiles(`conversations/${conversationId}/messages`, data);
};

export const findConversations = async (
  data: MilesPosNotesIntegrationService.Components.Schemas.FindConversationsRequest
): Promise<Required<MilesPosNotesIntegrationService.Components.Schemas.FindConversationsResponse>> => {
  const response = await callFes.postMiles('conversations/search', data);

  if (response.conversations.length === 0) {
    return {
      conversations: [],
      totalCount: 0,
    };
  }

  return response;
};

export const joinConversation = async (
  conversationId: string
): Promise<MilesPosNotesIntegrationService.Components.Schemas.JoinConversationResponse> => {
  return callFes.putMiles(`conversations/${conversationId}/join`, {});
};
